<template>
    <!-- <v-card> -->
      <div>
    <div class="message-container">
      <div class="message-scroll">
        <div class="message-detail" id="containerChat">
          <div class="message-box" :key="key" v-for="(chat, key) in chats">
            <v-card
              :color="chat.userID === ownerID ? '#77CAE7' : '#EFEEEF'"
              elevation="0"
              v-if="chat.type == 'message'"
              class="pa-3"
            >
              <!-- <div class="chat-avatar">
                <v-avatar :size="30" :justify="center">
                  <img :src="chat.userImg" />
                </v-avatar>
              </div>
              <div
                :class="chat.userID === ownerID ? 'chat-message owner-message':'chat-message'"
              >
                <div class="chat-name">{{chat.displayName}}</div>
                <div>{{chat.msg}}</div>
              </div>
              <div
                class="chat-time"
                :class="chat.userID === ownerID ? 'chat-time owner-message':'chat-time'"
              >
                <div>{{(new Date(chat.timeStamp)).getHours() }}:{{ (new Date(chat.timeStamp)).getMinutes() >= 10 ? (new Date(chat.timeStamp)).getMinutes() :`0${(new Date(chat.timeStamp)).getMinutes()}` }}</div>
              </div> -->

              <!--  -->
              <div class="container-left">
                <div class="chat-avatar">
                  <v-avatar :size="40" justify="center">
                    <img :src="chat.userImg" />
                  </v-avatar>
                </div>
              </div>
              <div class="container-right">
                <div
                  class="chat-time"
                  :class="
                    chat.userID === ownerID
                      ? 'chat-time owner-message'
                      : 'chat-time'
                  "
                >
                  <div>
                    {{ new Date(chat.timeStamp).getHours() }}:{{
                      new Date(chat.timeStamp).getMinutes() >= 10
                        ? new Date(chat.timeStamp).getMinutes()
                        : `0${new Date(chat.timeStamp).getMinutes()}`
                    }}
                  </div>
                </div>
              </div>
              <div class="container-center">
                <div
                  :class="
                    chat.userID === ownerID
                      ? 'chat-message owner-message'
                      : 'chat-message'
                  "
                >
                  <div class="chat-name">{{ chat.displayName }}</div>
                  <div>{{ chat.msg }}</div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
        <!-- <v-row>
          <v-col :cols="8" :lg="10" :md="10" :sm="8">
            <v-text-field
              class="input-chat"
              placeholder="Comment on Live"
              outlined
              v-model="msg"
              @keydown.enter="sendChat"
            ></v-text-field>
          </v-col>
          <v-col :cols="4" :lg="2" :md="2" :sm="4">
            <div>
              <v-btn
                width="100%"
                height="48px"
                class="mb-md-7 xs-full-width title"
                color="#30AEE3"
                large
                dark
                @click="sendChat"
              >Send</v-btn>
            </div>
          </v-col>
        </v-row> -->
        <!-- <div class="send-message-container">
          <div
           class="send-message-input"
          >
            <v-text-field
              class="sender-input"
              height="45px"
              placeholder="Comment on Live"
              outlined
              v-model="msg"
              @keydown.enter="sendChat"
            ></v-text-field>
          </div>
          <div
            class="send-message-btn"
          >
            <v-btn
              width="100%"
              height="45px"
              class="sender-btn"
              large
              dark
              elevation="0"
              @click="sendChat"
              >Send</v-btn
            >
          </div>
        </div> -->
      </div>
      
    </div><div class="send-message-container">
          <div
           class="send-message-input"
          >
            <v-text-field
              class="sender-input"
              height="45px"
              placeholder="Comment on Live"
              outlined
              v-model="msg"
              @keydown.enter="sendChat"
            ></v-text-field>
          </div>
          <div
            class="send-message-btn"
          >
            <v-btn
              width="100%"
              height="45px"
              class="sender-btn"
              large
              dark
              elevation="0"
              @click="sendChat"
              >Send</v-btn
            >
          </div>
        </div>
      </div>
</template>
<script>
// import * as firebase from "firebase";
// var config = {
//   apiKey: "AIzaSyCvQEwP5Kp5iBb78AvdjwHe5wfG2ruOvbA",
//   authDomain: "deknerd-556e6.firebaseapp.com",
//   databaseURL: "https://deknerd-556e6.firebaseio.com",
//   projectId: "deknerd-556e6",
//   storageBucket: "deknerd-556e6.appspot.com",
//   messagingSenderId: "434518633712",
//   appId: "1:434518633712:web:d564d8f1be8efe1014a635"
// };
// firebase.initializeApp(config);
import firebase from '@/service/firebase';
var database = firebase.database();
// var coursesRef = database
//   .ref("/courses")
//   .child("/course12")
//   .child("/live30");

// var onlineUserRef = database.ref("/onlineUser").child("/live30");

// var connectedRef = database.ref(".info/connected");
// import { getLiveStreamStudio } from "@/service/course/live";
import $ from 'jquery';
export default {
  name: 'login',
  props: {
    chatRoom: {
      type: String,
    },
  },
  data: () => ({
    chats: [],
    msg: '',
    userImg: null,
    userID: null,
    displayName: null,
    ownerID: null,
    liveStreamDetail: null,
    coursesRef: null,
    // width: 0
  }),
  watch: {
    chatRoom(value) {
      console.log("yes")
      if (value) {
        this.changeChatRoom()
      }
    },
  },
  async mounted() {
    // this.coursesRef = database
    //   .ref(`/courses/${this.chatRoom}`)
    //   console.log(`/courses/${this.chatRoom}`)
    //   // .child(`/${this.courseId}`)
    //   // .child(`/${this.chatRoom}`);
    // this.coursesRef.on("value", snapshot => {
    //   console.log(snapshot.val());
    //   this.chats = snapshot.val();
    //   setTimeout(function() {
    //     $("#containerChat").scrollTop($("#containerChat")[0].scrollHeight);
    //   }, 100);
    // });

    // connectedRef.on("value", function(snap) {
    //   if (snap.val() === true) {
    //     console.log("YES");
    //     // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
    //     var con = onlineUserRef.push();

    //     // When I disconnect, remove this device
    //     con.onDisconnect().remove();

    //     // Add this device to my connections list
    //     // this value could contain info about the device or a timestamp too
    //     con.set(true);

    //     // When I disconnect, update the last time I was seen online
    //     // lastOnlineRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP);
    //   }
    // });
    this.ownerID = this.$store.state._id;
    this.userImg = this.$store.state.image;
    this.displayName = this.$store.state.displayName;
    if(this.chatRoom){
      this.changeChatRoom()
    }
    // coursesRef.set(null)
  },
  computed: {},
  methods: {
    async sendChat() {
      if (this.msg.length > 0) {
        let chatPayload = {
          msg: this.msg,
          // questionID: "5ea69390703dc757e34a46a6",
          userID: this.ownerID,
          userImg: this.userImg,
          // timeStamp1: new Date().getTime(),
          timeStamp: firebase.database.ServerValue.TIMESTAMP,
          type: 'message',
          // type: "question",
          isTeacher: true,
          displayName: this.displayName,
        };
        
        await this.coursesRef.push(chatPayload);
        this.msg = '';
      }
    },
    async changeChatRoom() {
        if(this.coursesRef){
        this.coursesRef.off('value')
        this.coursesRef = null;
        }
        this.coursesRef = database.ref(`${this.chatRoom}`);
        // .child(`/${this.courseId}`)
        // .child(`/${this.chatRoom}`);
        this.coursesRef.on('value', (snapshot) => {
          this.chats = snapshot.val();
          setTimeout(function () {
            $('#containerChat').scrollTop($('#containerChat')[0].scrollHeight);
          }, 100);
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.message-container {
  position: relative;
  // padding: 12px;
  // padding-top: 12px;
  // height: 77vh;
  height: calc(100vh - 73px - 108px - 65px);
  border-style: unset !important;
}
@media only screen and (max-width: 768px) {
  .message-container {
    height: unset;
  }
}
.message-scroll {
  // height: 80vh;
  height: calc(100vh - 73px - 108px - 65px);;
  // overflow: hidden;
}
.message-detail {
  /* background-color: ghostwhite; */
  // height: 85%;
  height: 100%;
  /* margin-bottom: 10px; */
  overflow-y: scroll;
  /* overflow: hidden; */
  padding-top: 15px;
}
.message-detail:hover {
  /* background-color: ghostwhite; */
  /* height: 470px; */
  /* margin-bottom: 10px; */
  /* overflow-y: scroll; */
  /* overflow: hidden; */
}
.chat-avatar {
  // padding: 12px;
  width: 50px;
  display: inline-table;
}
.chat-message {
  // padding: 10px;
  // padding: 12px 12px 12px 0px;
  // display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.chat-name {
  font-weight: bold;
}
.chat-time {
  font-weight: bold;
  // padding: 10px;
  width: 80px;
  // float: right;
  text-align: right;
  font-size: 16px;
}
.owner-message {
  color: white;
}
/* .send-message-container{

} */
.send-message-container {
  /* position: relative; */
  /* height: 200px; */
  /* border: 3px solid red; */
  /* position: absolute; */
  /* width: 100%; */
  /* bottom: 10px; */
  // position: absolute;
  // bottom: 10px;
  // width: 92%;
  display: flex;
  padding: 10px;
}

.send-message-input {
  /* position: absolute;
  bottom: 10px; */
  /* border: 3px solid #8AC007; */
  width: calc(100% - 78px);
  padding-right: 10px;
}
.send-message-btn {
  // float: right;
  /* display: inline-block; */
  width: 78px;
}
.message-box {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 8px;
}
.send-container {
  padding-left: 10px;
  padding-right: 10px;
}

.container-left {
  width: 60px;
  float: left;
}

.container-right {
  width: 60;
  float: right;
}

.container-center {
  width: calc(100% - 60px - 60px);
  margin: 0 auto;
}

.send-container-right {
  width: 80px !important;
  float: right;
  margin-right: 20px;
  padding-top: 18px;
  // padding: 10px 0px 0px 0px;
}
.send-container-left {
  width: calc(95% - 80px);
  // margin:0 auto;
  float: left;
}
.sender-input {
  // padding-right: 5px;
  // padding-left: 10px;
  // padding-top: 10px;
  border-radius: 0px !important;
}
.sender-btn {
  border-radius: 0px;
  background-color: #77cae7 !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  min-height: 50px;
}
</style>
<style >
.sender-input > .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 50px;
}
</style>
<style lang="scss">
.sender-input {
  .v-text-field__details {
    display:none
  }
  .v-input__slot {
    margin-bottom: 0px;
  }
}
</style>